import { Injectable } from '@angular/core';
import { NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
@Injectable({
    providedIn: 'root'
})
export class FormatDateService extends NgbDateParserFormatter {

    parse(value: string): NgbDateStruct {
        if (value) {
            var delimiter = "/";
            if (value.includes("-"))
                delimiter = "-";
            else if (value.includes("."))
                delimiter = ".";
            const dateParts = value.trim().split(delimiter);
            if (dateParts.length === 1 && isNumber(dateParts[0])) {
                return { month: toInteger(dateParts[0]), day: null, year: null };
            } else if (dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
                return {
                    day: toInteger(dateParts[1]),
                    month: toInteger(dateParts[0]),
                    year: null
                };
            } else if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
                let strYear: string = dateParts[2];
                if (strYear.length == 4) {
                    return {
                        day: toInteger(dateParts[1]),
                        month: toInteger(dateParts[0]),
                        year: toInteger(dateParts[2])
                    }
                }
                else
                    return {
                        day: toInteger(dateParts[1]),
                        month: toInteger(dateParts[0]),
                        year: null
                    }
            }
            return null;
        }
        else
            return { day: null, month: null, year: null }
    }
    format(date: NgbDateStruct): string {
        return date
            ? `${isNumber(date.month) ? padNumber(date.month) : ""}/${isNumber(date.day) ? padNumber(date.day) : ""}/${
            date.year
            }`
            : "";
    }
}
export function toInteger(value: any): number {
    return parseInt(`${value}`, 10);
}

export function isNumber(value: any): value is number {
    return !isNaN(toInteger(value));
}

export function padNumber(value: number) {
    if (isNumber(value)) {
        return `0${value}`.slice(-2);
    } else {
        return "";
    }
}
